import { render } from "./Users.vue?vue&type=template&id=31113758"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/admin/Users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31113758"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31113758', __exports__)) {
    api.reload('31113758', __exports__)
  }
  
  module.hot.accept("./Users.vue?vue&type=template&id=31113758", () => {
    api.rerender('31113758', render)
  })

}


export default __exports__